// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var ErrorType;
(function (ErrorType) {
    ErrorType["ERROR_TYPE_UNKNOWN"] = "ERROR_TYPE_UNKNOWN";
    ErrorType["ERROR_TYPE_VALIDATION"] = "ERROR_TYPE_VALIDATION";
    ErrorType["ERROR_TYPE_PARTNER"] = "ERROR_TYPE_PARTNER";
    ErrorType["ERROR_TYPE_SKIP"] = "ERROR_TYPE_SKIP";
})(ErrorType || (ErrorType = {}));
export var ErrorType_index;
(function (ErrorType_index) {
    ErrorType_index[ErrorType_index["ERROR_TYPE_UNKNOWN"] = 0] = "ERROR_TYPE_UNKNOWN";
    ErrorType_index[ErrorType_index["ERROR_TYPE_VALIDATION"] = 1] = "ERROR_TYPE_VALIDATION";
    ErrorType_index[ErrorType_index["ERROR_TYPE_PARTNER"] = 2] = "ERROR_TYPE_PARTNER";
    ErrorType_index[ErrorType_index["ERROR_TYPE_SKIP"] = 3] = "ERROR_TYPE_SKIP";
})(ErrorType_index || (ErrorType_index = {}));
export var ValidationErrorCode;
(function (ValidationErrorCode) {
    ValidationErrorCode["UNKNOWN_VALIDATION_ERROR"] = "UNKNOWN_VALIDATION_ERROR";
    ValidationErrorCode["MISSING_MEMBER_ID"] = "MISSING_MEMBER_ID";
    ValidationErrorCode["MISSING_FIRST_NAME"] = "MISSING_FIRST_NAME";
    ValidationErrorCode["MISSING_LAST_NAME"] = "MISSING_LAST_NAME";
    ValidationErrorCode["MISSING_PAYER_ID"] = "MISSING_PAYER_ID";
    ValidationErrorCode["MISSING_DOB"] = "MISSING_DOB";
    ValidationErrorCode["MISSING_NPI"] = "MISSING_NPI";
    ValidationErrorCode["NOT_SUPPORTED_PAYER"] = "NOT_SUPPORTED_PAYER";
    ValidationErrorCode["MISSING_PROVIDER_TAX_ID"] = "MISSING_PROVIDER_TAX_ID";
    ValidationErrorCode["MISSING_PROVIDER_FIRST_NAME"] = "MISSING_PROVIDER_FIRST_NAME";
    ValidationErrorCode["MISSING_PROVIDER_LAST_NAME"] = "MISSING_PROVIDER_LAST_NAME";
    ValidationErrorCode["MISSING_PROVIDER_ORGANIZATION_NAME"] = "MISSING_PROVIDER_ORGANIZATION_NAME";
    ValidationErrorCode["MISSING_PROVIDER_TYPE"] = "MISSING_PROVIDER_TYPE";
    ValidationErrorCode["MISSING_PATIENT_RELATIONSHIP"] = "MISSING_PATIENT_RELATIONSHIP";
    ValidationErrorCode["MISSING_SUBSCRIBER_DETAILS"] = "MISSING_SUBSCRIBER_DETAILS";
    ValidationErrorCode["MISSING_SUBSCRIBER_FIRST_NAME"] = "MISSING_SUBSCRIBER_FIRST_NAME";
    ValidationErrorCode["MISSING_SUBSCRIBER_LAST_NAME"] = "MISSING_SUBSCRIBER_LAST_NAME";
    ValidationErrorCode["MISSING_SUBSCRIBER_DOB"] = "MISSING_SUBSCRIBER_DOB";
    ValidationErrorCode["MISSING_SUBSCRIBER_MEMBER_ID"] = "MISSING_SUBSCRIBER_MEMBER_ID";
    ValidationErrorCode["FAILED_TO_GET_PROVIDER_DETAILS_FROM_NPI"] = "FAILED_TO_GET_PROVIDER_DETAILS_FROM_NPI";
    ValidationErrorCode["INVALID_PROVIDER_TAX_ID"] = "INVALID_PROVIDER_TAX_ID";
})(ValidationErrorCode || (ValidationErrorCode = {}));
export var ValidationErrorCode_index;
(function (ValidationErrorCode_index) {
    ValidationErrorCode_index[ValidationErrorCode_index["UNKNOWN_VALIDATION_ERROR"] = 0] = "UNKNOWN_VALIDATION_ERROR";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_MEMBER_ID"] = 1] = "MISSING_MEMBER_ID";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_FIRST_NAME"] = 2] = "MISSING_FIRST_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_LAST_NAME"] = 3] = "MISSING_LAST_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_PAYER_ID"] = 4] = "MISSING_PAYER_ID";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_DOB"] = 5] = "MISSING_DOB";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_NPI"] = 6] = "MISSING_NPI";
    ValidationErrorCode_index[ValidationErrorCode_index["NOT_SUPPORTED_PAYER"] = 7] = "NOT_SUPPORTED_PAYER";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_PROVIDER_TAX_ID"] = 8] = "MISSING_PROVIDER_TAX_ID";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_PROVIDER_FIRST_NAME"] = 9] = "MISSING_PROVIDER_FIRST_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_PROVIDER_LAST_NAME"] = 10] = "MISSING_PROVIDER_LAST_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_PROVIDER_ORGANIZATION_NAME"] = 11] = "MISSING_PROVIDER_ORGANIZATION_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_PROVIDER_TYPE"] = 12] = "MISSING_PROVIDER_TYPE";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_PATIENT_RELATIONSHIP"] = 13] = "MISSING_PATIENT_RELATIONSHIP";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_SUBSCRIBER_DETAILS"] = 14] = "MISSING_SUBSCRIBER_DETAILS";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_SUBSCRIBER_FIRST_NAME"] = 15] = "MISSING_SUBSCRIBER_FIRST_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_SUBSCRIBER_LAST_NAME"] = 16] = "MISSING_SUBSCRIBER_LAST_NAME";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_SUBSCRIBER_DOB"] = 17] = "MISSING_SUBSCRIBER_DOB";
    ValidationErrorCode_index[ValidationErrorCode_index["MISSING_SUBSCRIBER_MEMBER_ID"] = 18] = "MISSING_SUBSCRIBER_MEMBER_ID";
    ValidationErrorCode_index[ValidationErrorCode_index["FAILED_TO_GET_PROVIDER_DETAILS_FROM_NPI"] = 19] = "FAILED_TO_GET_PROVIDER_DETAILS_FROM_NPI";
    ValidationErrorCode_index[ValidationErrorCode_index["INVALID_PROVIDER_TAX_ID"] = 20] = "INVALID_PROVIDER_TAX_ID";
})(ValidationErrorCode_index || (ValidationErrorCode_index = {}));
export const InsuranceVerificationAdapterService = {
    GetDentalCoverageInfo(fn, req) {
        return fn(`/insurance-verification/v2/dental-coverage-info`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    AddLocationNpiDetails(fn, req) {
        return fn(`/insurance-verification/v2/add-location-npi`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateLocationNpiDetails(fn, req) {
        return fn(`/insurance-verification/v2/update-location-npi`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListLocationNpi(fn, req) {
        return fn(`/insurance-verification/v2/location-npi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetCachedDentalCoverageInfoByPersonId(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v2/person/${req["personId"]}/dental-coverage-info?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "GET" });
    },
    GetCoverageStatusCountsByOrg(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v2/org/${req["orgId"]}/status/count?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
    ListPersonsCoverageStatusByOrg(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insurance-verification/v2/org/${req["orgId"]}/status?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
    GetInsuranceCoverageInfo(fn, req) {
        return fn(`/insurance-verification/v2/insurance-coverage-info`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetInsuranceEligibilityReport(fn, req) {
        return fn(`/insurance-verification/v2/insurance-eligibility-report?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetPVerifyPracticeType(fn, req) {
        return fn(`/insurance-verification/v2/practice-type?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetInsuranceVerificationDetails(fn, req) {
        return fn(`/insurance-verification/v2/insurance-verification-details?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetIFrameConnectionURL(fn, req) {
        return fn(`/insurance-verification/v2/iframe-connection-url?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    DentalInsuranceCoverageWebhook(fn, req) {
        return fn(`/insurance-verification/v2/webhook/dental-insurance-info`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetInsuranceStatusByPersonIds(fn, req) {
        return fn(`/insurance-verification/v2/insurance-status-by-person-ids`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    TriggerBIReporting(fn, req) {
        return fn(`/insurance-verification/v2/trigger-bi-reporting`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
